import axios from "axios";
import type { InternalAxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { API_BASE_URLS } from "@/config";

const getBaseUrl = () => {
    if (import.meta.env.DEV) {
        return API_BASE_URLS.STAGING;
    }
    return API_BASE_URLS.PRODUCTION;
};

export const api = axios.create({
    baseURL: getBaseUrl(),
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

// Add request interceptor for logging
api.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        // You can add auth tokens or other headers here
        return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    },
);

// Add response interceptor for error handling
api.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
        // Handle errors here
        return Promise.reject(error);
    },
);
